import { Box, Checkbox, CircularProgress, Grid } from '@atgfr8/atg-ui-tailwind';
import {
  ediConfigurationStore,
  setEdiConfigurationStore,
} from '@store/customers/customerDetails';
import { isReadonly } from '@utils/utils';
import { Index, Show } from 'solid-js';
import { produce } from 'solid-js/store';

import { FeaturedFlagClasses as classes } from './classes';

const FeaturedFlag = () => {
  const labelObject: { [key: string]: string } = {
    isEDI210RulesEnabled: 'Enable 210 Rules',
    isEDI214RulesEnabled: '214 Load Update Rules',
    isEDI990RulesEnabled: '990 Tender Response Rules',
    isEDIHandleTenderRulesEnabled: 'Handle Tender Rules',
    isEDIOnLoadRulesEnabled: 'On Load Create Rules',
    isEDI214NotificationsEnabled: 'Enable X6 Auto Update',
    isEDIChangeTender990Enabled: '990 Change Tender',
    isEDIAutoVoidEnabled: 'Enable Auto Void',
    isEDIChangeTenderEmailNotificationEnabled:
      'Change Tender Email Notification',
    isEDIRejectChangeTenderEnabled: 'Reject Change Tender',
    isUpdateStopArrival: 'Update Stop Arrival',
    isEDIReopenLoadChangeTender: 'Reopen Load Change Tender',
    isEDIPickupDriverInAuto214: 'Pickup Driver in Auto 214',
    isEDIDropoffDriverInAuto214: 'Dropoff Driver in Auto 214',
    isEDIPickupDriverOutAuto214: 'Pickup Driver Out Auto 214',
    isEDIDropoffDriverOutAuto214: 'Dropoff Driver Out Auto 214',
    isEDIPickupAppointmentAuto214: 'Pickup Appointment Auto 214',
    isEDIDropoffAppointmentAuto214: 'Dropoff Appointment Auto 214',
    isEDITenderAuto990AcceptDeclineEnabled: 'Tender Auto 990 Accept Decline',
    isEDIValidationTesting204Enabled: 'EDI Validation Testing 204',
    isEDIValidationTesting210Enabled: 'EDI Validation Testing 210',
    isEDIValidationTesting214Enabled: 'EDI Validation Testing 214',
    isEDIValidationTesting990Enabled: 'EDI Validation Testing 990',
  };

  const handleFeatureFlagChange = (
    flag: keyof typeof ediConfigurationStore.ediData.featureFlags,
  ) => {
    setEdiConfigurationStore(
      'ediData',
      'featureFlags',
      produce((draft) => {
        draft[flag as keyof typeof ediConfigurationStore.ediData.featureFlags] =
          !draft[
            flag as keyof typeof ediConfigurationStore.ediData.featureFlags
          ];
      }),
    );
  };

  return (
    <Box class={classes.containerClass}>
      <Show
        when={!ediConfigurationStore.isLoading}
        fallback={<CircularProgress class={classes.loaderStyle} />}
      >
        <Grid container>
          <Index each={Object.keys(ediConfigurationStore.ediData.featureFlags)}>
            {(flag) => {
              return (
                <Show
                  when={flag() !== 'isEDITenderAuto990AcceptDeclineEnabled'}
                >
                  <Grid item size={{ xs: 12, md: 6, lg: 6 }}>
                    <Checkbox
                      label={labelObject[flag()] || 'No Label'}
                      checked={
                        ediConfigurationStore.ediData.featureFlags[
                          flag() as keyof typeof ediConfigurationStore.ediData.featureFlags
                        ]
                      }
                      disabled={isReadonly()}
                      onChange={() =>
                        handleFeatureFlagChange(
                          flag() as keyof typeof ediConfigurationStore.ediData.featureFlags,
                        )
                      }
                      dataTestId={`featured-flag-${flag()}-checkboxInput`}
                      size="xs"
                      color="info"
                      class="ml-[-9px]"
                    />
                  </Grid>
                </Show>
              );
            }}
          </Index>
        </Grid>
      </Show>
    </Box>
  );
};

export default FeaturedFlag;
